<template>
  <div class="page">
    <div>
      <br />
      <div class="feature-intro">
        <h1>Editando Contraseña</h1>
        <p>Modifique los datos que desea EDITAR</p>
        <ProgressSpinner
          v-if="loader"
          class="spinner"
          style="width: 50px; height: 50px"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration="1.5s"
        />
      </div>

      <div class="py-2">
        <label for="contrasenaAnterior.value" class="block">Contraseña Anterior</label>
        <Password
          :feedback="false"
          toggleMask
          id="contrasenaAnterior"
          v-model="contrasenaAnterior.value"
          test-id="contrasenaAnterior"
          @keyup.enter="save"
          placeholder="Contraseña Anterior"
          class="p-fluid p-input w-full"
          :class="{ 'p-invalid': contrasenaAnterior.error, 'py-2': true }"
        />
        <div v-show="contrasenaAnterior.error" class="text-red-600 text-sm">
          {{ contrasenaAnterior.mensaje }}
        </div>
      </div>

      <div class="py-2">
        <label for="nuevaContrasena.value" class="block">Nueva Contraseña</label>
        <Password
          :feedback="false"
          toggleMask
          id="nuevaContrasena"
          v-model="nuevaContrasena.value"
          test-id="nuevaContrasena"
          @keyup.enter="save"
          placeholder="Nueva Contraseña"
          class="p-fluid p-input w-full"
          :class="{ 'p-invalid': nuevaContrasena.error, 'py-2': true }"
        />
        <div v-show="nuevaContrasena.error" class="text-red-600 text-sm">
          {{ nuevaContrasena.mensaje }}
        </div>
      </div>

      <div class="py-2">
        <label for="repitaNuevaContrasena.value" class="block">Repita Nueva Contraseña</label>
        <Password
          :feedback="false"
          toggleMask
          id="repitaNuevaContrasena"
          v-model="repitaNuevaContrasena.value"
          test-id="repitaNuevaContrasena"
          @keyup.enter="save"
          placeholder="Repita Nueva Contraseña"
          class="p-fluid p-input w-full"
          :class="{ 'p-invalid': repitaNuevaContrasena.error, 'py-2': true }"
        />
        <div v-show="repitaNuevaContrasena.error" class="text-red-600 text-sm">
          {{ repitaNuevaContrasena.mensaje }}
        </div>
      </div>

      <div class="mt-4 flex justify-content-between p-mt-6">
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text p-button-secondary"
          @click="back"
          test-id="cancelButton"
        />
        <Button label="Guardar" icon="pi pi-check" @click="save" test-id="edit-boton-guardar" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRouterCompat } from "@/composables/useRouterCompat.js";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useRest } from "@/composables/useRest";
import { useToast } from "@/composables/useToast";

import axios from "axios";
import Password from "primevue/password";

const store = useStoreCompat();
const { router } = useRouterCompat();
const rest = useRest();
const toast = useToast();

const loader = ref(false);


const contrasenaAnterior = reactive({ value: "", error: false, mensaje: "" });
const nuevaContrasena = reactive({ value: "", error: false, mensaje: "" });
const repitaNuevaContrasena = reactive({ value: "", error: false, mensaje: "" });

function back() {
  router.push("/");
}

function validacion() {
  contrasenaAnterior.error = !contrasenaAnterior.value.trim();
  contrasenaAnterior.mensaje = contrasenaAnterior.error ? "Este campo no puede quedar vacío" : "";

  nuevaContrasena.error = !nuevaContrasena.value.trim();
  nuevaContrasena.mensaje = nuevaContrasena.error ? "Este campo no puede quedar vacío" : "";

  repitaNuevaContrasena.error = !repitaNuevaContrasena.value.trim();
  repitaNuevaContrasena.mensaje = repitaNuevaContrasena.error
    ? "Este campo no puede quedar vacío"
    : "";

  if (/\s/.test(nuevaContrasena.value)) {
    nuevaContrasena.error = true;
    nuevaContrasena.mensaje = "La contraseña no debe contener espacios";
    return false;
  }

  if (nuevaContrasena.value.length < 8) {
    nuevaContrasena.error = true;
    nuevaContrasena.mensaje = "La Nueva contraseña debe tener al menos 8 caracteres";
    return false;
  }

  const letras = nuevaContrasena.value.split("");
  const tieneMayuscula = letras.some((c) => "ABCDEFGHIJKLMNOPQRSTUVWXYZÑ".includes(c));
  const tieneMinuscula = letras.some((c) => "abcdefghijklmnopqrstuvwxyzñ".includes(c));
  const tieneNumero = letras.some((c) => "0123456789".includes(c));

  if (!tieneMayuscula) {
    nuevaContrasena.error = true;
    nuevaContrasena.mensaje = "Debe tener al menos una mayúscula";
    return false;
  }

  if (!tieneMinuscula) {
    nuevaContrasena.error = true;
    nuevaContrasena.mensaje = "Debe tener al menos una minúscula";
    return false;
  }

  if (!tieneNumero) {
    nuevaContrasena.error = true;
    nuevaContrasena.mensaje = "Debe tener al menos un número";
    return false;
  }

  if (nuevaContrasena.value !== repitaNuevaContrasena.value) {
    nuevaContrasena.error = repitaNuevaContrasena.error = true;
    nuevaContrasena.mensaje = repitaNuevaContrasena.mensaje = "Las contraseñas no coinciden";
    return false;
  }

  return !(contrasenaAnterior.error || nuevaContrasena.error || repitaNuevaContrasena.error);
}

async function save() {
  if (!validacion()) return;

  loader.value = true;
  try {
    await axios.put(
      `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/parametros/contrasena/`,
      {
        "Contraseña Anterior": contrasenaAnterior.value,
        "Nueva Contraseña": nuevaContrasena.value.trim(),
      },
      { withCredentials: true }
    );

    toast.toast_open({
      message: "La Contraseña se cambió con éxito",
      position: "top-right",
      type: "success",
      duration: 3000,
    });

    await store.dispatch("user/logout");
    back();
  } catch (error) {
    console.log("error", error);
    loader.value = false;
    const errorMessage = error.response?.data?.error;
    if (errorMessage === "Contraseña incorrecta") {
      contrasenaAnterior.error = true;
      contrasenaAnterior.mensaje = "La contraseña ingresada es incorrecta.";
    } else {
      toast.toast_open({
        message: "No se pudo realizar el cambio. Intente más tarde",
        position: "top-right",
        type: "error",
        duration: 3000,
      });
      back();
    }
  }
}


defineExpose({
  contrasenaAnterior,
  nuevaContrasena,
  repitaNuevaContrasena,
  loader,
  validacion,
  save,
})
</script>

<style scoped></style>
